import CustomerSubjectResultBatchIcon from '@material-ui/icons/ViewList';

import LearningOutcomeBatchList from './LearningOutcomeBatchList';
import LearningOutcomeBatchCreate from './LearningOutcomeBatchCreate';
import {LearningOutcomeBatchEdit} from "./LearningOutcomeBatchEdit";

export default {
    list: LearningOutcomeBatchList,
    create: LearningOutcomeBatchCreate,
    edit: LearningOutcomeBatchEdit,
    icon: CustomerSubjectResultBatchIcon,
};
